import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '../consts/url';
import { OrgUserModels } from '../models/org-user.model';

const ORG_USERS_LIMIT = 1000;
const ORG_USERS_OFFSET = 0;
const ORG_USERS_ORDER_BY = 'email';
const ORG_USERS_ORDER_DIRECTION = 'asc';

@Injectable({ providedIn: 'root' })
export class OrgUsersService {
  private readonly http = inject(HttpClient);

  public getOrgUsers(): Observable<OrgUserModels.GetOrgUsersResponse> {
    const url =
      `${api.orgUsers.all}?limit=${ORG_USERS_LIMIT}&offset=${ORG_USERS_OFFSET}` +
      `&orderBy=${ORG_USERS_ORDER_BY}&orderDirection=${ORG_USERS_ORDER_DIRECTION}`;
    return this.http.get<OrgUserModels.GetOrgUsersResponse>(url);
  }
}
